import { render, staticRenderFns } from "./PreviewBlocoTexto.vue?vue&type=template&id=30f2a362&scoped=true"
import script from "./PreviewBlocoTexto.vue?vue&type=script&lang=js"
export * from "./PreviewBlocoTexto.vue?vue&type=script&lang=js"
import style0 from "./PreviewBlocoTexto.vue?vue&type=style&index=0&id=30f2a362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f2a362",
  null
  
)

export default component.exports